/**
 * Creates a new Suspense ready Store
 */
export const createStore = (initialValue) => {
    const subscribers = new Set();
    const cancelations = new Set();
    let value = initialValue;
    const read = () => value;
    const readInitial = () => initialValue;
    const set = (val) => {
        value = val;
        // Cancel previous, dangling operations
        cancelations.forEach((cancel) => cancel());
        cancelations.clear();
        // Broadcast subscribers
        subscribers.forEach((sub) => {
            const cancel = sub(val);
            if (typeof cancel === "function") {
                cancelations.add(cancel);
            }
        });
    };
    const subscribe = (sub) => {
        subscribers.add(sub);
        return () => {
            subscribers.delete(sub);
        };
    };
    return {
        set,
        read,
        readInitial,
        subscribe,
    };
};
//# sourceMappingURL=base.js.map